module.exports = __webpack_public_path__ + "static/IMG-20200724-WA0022-0b91ea5be670276e36fa8d2949807dd1.jpg";